import '../../../../assets/css/screens/customer/dashboard/postajob/PostAJob.css';
import React, { useState, useRef, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import {
  ArrowLeft, Tag, FileText, DollarSign,
  MapPin, Calendar, ImagePlus, Send, X, Gavel, Crown, ChevronDown
} from 'lucide-react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import { useLocation } from 'react-router-dom';


const PostAJob = () => {
  const navigate = useNavigate();
  const { baseUrl, RegExpChecker } = useContext(AppContext);
  const [categories, setCategories] = useState([]);

  const fileRef = useRef(null);
  const [categoryId, setCategoryId] = useState("");
  const [serviceType, setServiceType] = useState(""); // sirf display ke liye
  const [jobTitle, setJobTitle] = useState('');
  const [description, setDescription] = useState('');
  const [budget, setBudget] = useState('');
  const [city, setCity] = useState('');
  const [address, setAddress] = useState('');
  const [deadline, setDeadline] = useState('');

  const [bidding, setBidding] = useState('');
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});
  const location = useLocation();
  const [cities, setCities] = useState([
    "Portland",
    "Beaverton",
    "Gresham",
    "Hillsboro",
    "Lake Oswego",
    "Tigard",
    "Oregon City",
    "West Linn",
    "Milwaukie",
    "Happy Valley"
  ]);

const getMinDateTime = () => {
  const now = new Date();

  now.setMinutes(now.getMinutes() + 1);

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
  const serviceTypeRef = useRef(null);
  const jobTitleRef = useRef(null);
  const descriptionRef = useRef(null);
  const budgetRef = useRef(null);
  const cityRef = useRef(null);
  const addressRef = useRef(null);
  const deadlineRef = useRef(null);

  const biddingRef = useRef(null);


  useEffect(() => {
    console.log("Location State:", location.state);

    if (location.state?.category) {
      console.log("Category:", location.state.category);

      setServiceType(location.state.category.categoryName);
      setCategoryId(location.state.category.id);
    }
  }, [location.state]);


  const [hasSubscription, setHasSubscription] = useState(false);


  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!categoryId) {
      serviceTypeRef.current.focus();
      return;
    }

    if (!jobTitle.trim()) {
      jobTitleRef.current.focus();
      return;
    }

    if (!description.trim()) {
      descriptionRef.current.focus();
      return;
    }

    if (!budget) {
      budgetRef.current.focus();
      return;
    }

    if (!city) {
      cityRef.current.focus();
      return;
    }

    if (!address.trim()) {
      addressRef.current.focus();
      return;
    }

    if (!deadline) {
      deadlineRef.current.focus();
      return;
    }


    if (!bidding) {
      biddingRef.current.focus();
      return;
    }



    setLoading(true);

    try {

        console.log("Deadline value:", deadline);
      const formData = new FormData();

      formData.append("whcategory_id", categoryId);
      formData.append("jobTitle", jobTitle);
      formData.append("description", description);
      formData.append("budget", budget);
      formData.append("city", city);
      formData.append("address", address);
      formData.append("deadline", deadline);
   
      formData.append("bidding", bidding === "yes" ? 1 : 0);


      media.forEach(fileObj => {
        formData.append("media[]", fileObj.file);
      });



      const response = await axios.post(
        `${baseUrl}/customer/postjob`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );


      console.log(response.data);



      // yahan limit check hoga
      if (response.data.success === false) {

        Swal.fire({
          icon: "warning",
          title: "Bid Limit Reached",
          text: response.data.message,
          confirmButtonText: "Upgrade Plan"
        }).then((result) => {

          if (result.isConfirmed) {
            navigate("/customer-subscription");
          }

        });

        return;
      }



     if (response.data.success) {


  // Agar bidding job hai to Stripe nahi kholna
  if (bidding === "yes") {


   


    navigate("/my-jobs");


  } else {


    // Normal job ke liye Stripe open hoga
    const stripeResponse = await axios.post(
      `${baseUrl}/customer/payment`,
      {
        job_id: response.data.job_id
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );


    if (stripeResponse.data.success) {

      window.location.href = stripeResponse.data.checkout_url;

    }

  }

}

    }
    catch (err) {

      console.log(err.response?.data || err);

    

    }
    finally {

      setLoading(false);

    }

  }

  // const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleMedia = (e) => {
    const files = Array.from(e.target.files);

    files.forEach(file => {
      const url = URL.createObjectURL(file);
      setMedia(m => [...m, { file, url, name: file.name, type: file.type }]);
    });
  };

  const removeMedia = (i) => setMedia(m => m.filter((_, idx) => idx !== i));

  // category call karna k liya drop down mey 
  useEffect(() => {
    axios.get(`${baseUrl}/customer/viewcategories`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      }
    })
      .then((response) => {
        console.log(response.data);

        const data = response.data.categories || [];

        const activeCategories = data.filter(
          cat => cat.status == 1
        );

        setCategories(activeCategories);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  // check subscription
  useEffect(() => {

    axios.get(`${baseUrl}/customer/checksubscription`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      }
    })
      .then(res => {

        setHasSubscription(res.data.hasSubscription);

      })
      .catch(err => {
        console.log(err);
      });

  }, []);
  const today = new Date().toISOString().split("T")[0];
  const now = new Date();

  const currentTime =
    `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

const getMinTime = () => {
  const now = new Date();

  return `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
};
  return (
    <>
      <AppNavbar />
      <div className="pj-page">
        <div className="pj-container">

          {/* ── Header ── */}
          <div className="pj-header">
            <button className="pj-back" onClick={() => navigate(-1)}>
              <ArrowLeft size={20} />
            </button>
            <h2 className="pj-title">Post a Job</h2>
          
          </div>
          <div>
              <p className="pj-note">
   All fields marked with <span>*</span> are mandatory.
</p>
          </div>



          <form className="pj-form" onSubmit={handleSubmit}
            noValidate>

            {/* Service Type */}
            <div className="pj-custom-select">

           <div className="pj-select-wrapper">

  <select
    ref={serviceTypeRef}
    className="pj-input"
    value={categoryId}
    onChange={(e) => {
      setCategoryId(e.target.value);

      const selected = categories.find(
        c => c.id === Number(e.target.value)
      );

      setServiceType(selected?.categoryName || "");
    }}
  >
    <option value="">
      Select Service Type
    </option>

    {categories.map((cat) => (
      <option key={cat.id} value={cat.id}>
        {cat.categoryName}
      </option>
    ))}

  </select>

  <ChevronDown
    className="pj-select-icon"
    size={18}
  />

</div>

            </div>

            {/* Job Title */}
            <div className="pj-field">
              <label className="pj-label">
                <FileText size={15} />
                <span>Job Title</span>
                <span className="required">*</span>
              </label>
              <input
                ref={jobTitleRef}
                type="text"
                className="pj-input"
                placeholder="e.g., Fix kitchen sink leakage"
                value={jobTitle}
                onChange={e => setJobTitle(e.target.value)}

              />
            </div>

            {/* Job Description */}
            <div className="pj-field">
              <label className="pj-label">
                <FileText size={15} />
                Job Description
                <span className="required">*</span>
              </label>
              <textarea
                ref={descriptionRef}
                className="pj-textarea"
                placeholder="Describe the job in detail..."
                value={description}
                onChange={e => setDescription(e.target.value)}
                rows={5}

              />
            </div>



            <div className="pj-field">
              <label className="pj-label">
                <DollarSign size={15} />
                Budget / Tip
                <span className="required">*</span>
              </label>

              <div className="pj-budget-wrapper">



                <input
                  ref={budgetRef}
                  type="number"
                  className="pj-input"
                  placeholder="Enter budget"
                  value={budget}
                  onChange={e => setBudget(e.target.value)}
                  min="0"


                />
              </div>
            </div>

            {/* City */}
            <div className="pj-field">

              <label className="pj-label">
                <MapPin size={15} />
                City
                <span className="required">*</span>
              </label>
              <div className="pj-select-wrapper">
              
                <select
                  ref={cityRef}
                  className="pj-input pj-city-select"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}

                >
                  <option value="">Select City</option>

                  {cities.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>

                <ChevronDown
                  className="pj-select-icon"
                  size={18}
                />

              </div>
            </div>
            {/* Complete Address */}
            <div className="pj-field">
              <label className="pj-label">
                <MapPin size={15} />
                Job Location
                <span className="required">*</span>
              </label>
              <input
                ref={addressRef}
                type="text"
                className="pj-input"
                placeholder="Enter Job Location"
                value={address}
                onChange={e => setAddress(e.target.value)}
                
              />
            </div>

            {/* Deadline */}
           <div className="pj-field pj-deadline-field">
  <label className="pj-label">
    <Calendar size={15} />
    Deadline
    <span className="required">*</span>
  </label>

  <div className="deadline-wrapper">
    <Calendar className="deadline-icon" size={20} />

<input
  ref={deadlineRef}
  type="datetime-local"
  className="pj-input pj-deadline-input"
  value={deadline}
  min={getMinDateTime()}
  onChange={(e) => {

    const selectedDateTime = e.target.value;
    const currentDateTime = getMinDateTime();

    if (selectedDateTime < currentDateTime) {
      return;
    }

    setDeadline(selectedDateTime);
  }}
/>
  </div>

 
</div>

            {/* time */}
            {/* <div className="pj-field">

              <label className="pj-label">
                <Calendar size={15} />
                Time
                <span className="required">*</span>
              </label>

              <input
                ref={timeRef}
                type="time"
                className="pj-input"
                value={time}
                min={deadline === today ? currentTime : undefined}
                onChange={(e) => setTime(e.target.value)}
               
              /> */}

              {/* {errors.time && (
        <small className="pj-error">
            {errors.time}
        </small>
    )} */}

            {/* </div> */}

            {/* ── Bidding Field ── */}
          <div className="pj-field">

  <div className="pj-bidding-label-row">
    <label className="pj-label">
      <Gavel size={15} />
      Bidding
      <span className="required">*</span>
    </label>

    <button
      type="button"
      className="pj-bidding-pro-badge"
      title="Allow Bidding requires a Pro subscription"
    >
      <Crown size={11} />
      <span>Pro Feature</span>
    </button>
  </div>


  <div className="pj-select-wrapper">

    <select
      ref={biddingRef}
      className="pj-input"
      value={bidding}
      onChange={e => {

        const val = e.target.value;

        if (val === "yes" && !hasSubscription) {

          Swal.fire({
            icon: "info",
            title: "Premium Feature",
            text: "Bidding requires an active subscription. Please choose a plan.",
            confirmButtonText: "View Plans"
          }).then((result) => {

            if (result.isConfirmed) {
              navigate("/customer-subscription");
            }

          });

          return;
        }

        setBidding(val);

      }}
    >

      <option value="">
        Select bidding option
      </option>

      <option value="yes">
        🔒 Allow Bidding — Pro
      </option>

      <option value="no">
        No Bidding
      </option>

    </select>


    <ChevronDown
      className="pj-select-icon"
      size={18}
    />

  </div>

</div>

            {/* Upload Images / Videos */}
            <div className="pj-field">
              <label className="pj-label">
                <ImagePlus size={15} /> Upload Images / Videos
              </label>
              <p className="pj-upload-hint">Add media to help providers understand the job better.</p>
              <div className="pj-media-row">
                {media.map((m, i) => (
                  <div key={i} className="pj-media-thumb">
                    {m.type.startsWith('video')
                      ? <video src={m.url} className="pj-media-thumb__img" />
                      : <img src={m.url} alt={m.name} className="pj-media-thumb__img" />
                    }
                    <button
                      type="button"
                      className="pj-media-thumb__del"
                      onClick={() => removeMedia(i)}
                    >
                      <X size={12} />
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="pj-upload-btn"
                  onClick={() => fileRef.current.click()}
                >
                  <ImagePlus size={22} />
                  <span>Add</span>
                </button>
                <input

                  ref={fileRef}
                  type="file"
                  accept="image/*,video/*"
                  multiple
                  style={{ display: 'none' }}
                  onChange={handleMedia}
                />
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              className={'pj-submit' + (loading ? ' pj-submit--loading' : '')}
              disabled={loading}
            >
              {loading
                ? <span className="pj-submit__spinner" />
                : <><Send size={16} /> Post Job</>
              }
            </button>

          </form>
        </div>
      </div>
    </>
  );
};

export default PostAJob;